import { styled } from "@acko-tech/building-blocks.ui.common";

export const CardWrapper = styled.div`
  border-radius: 24px;
  border: 1px solid var(--Border-Default-grey100, #e8e8e8);
  background: #fff;
  padding: 32px 20px 24px 20px;
  @media (min-width: 768px) {
    border-radius: 40px;
  }
`;

export const HeaderSection = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const HeaderNumber = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const HeaderQuote = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-top: 1px dashed var(--Border-Default-grey100, #e8e8e8);
  margin: 16px 0px;
`;

export const ContentSection = styled.div`
  padding:0px;
`;

export const BulletContainer = styled.div`
  border-radius: 12px;
  background: rgba(68, 141, 238, 0.06);
  padding: 20px 12px;
  @media (min-width: 768px) {
    padding: 30px 16px;
  }
`;

export const BulletItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
    @media (min-width: 768px) {
     gap: 12px;
  }
`;

export const IconWrapper = styled.div`
  min-width: 45px;
  @media (min-width: 768px) {
    min-width: 64px;
  }
`;

export const BulletText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  @media (min-width: 768px) {
    color: var(--text-primary-n-600, #040222);
    font-family: "Euclid Circular B";
    font-size: 22.531px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.188px; /* 142.857% */
    align-self: center;
  }
`;

export const BulletDivider = styled.div`
  height: 1px;
  border-top: 1px solid var(--Border-Default-grey100, #e8e8e8);
  margin: 16px 0px;
  @media (min-width: 768px) {
    margin: 24px 0px;
  }
`;

export const VideoWrapper = styled.div`
  margin-top: 24px;

  video {
    border-radius: 12px;
  }
`;
